import React from "react";
import { ensure } from "sprint-common-web";

import { AssetType } from "../../../../../common/types/AssetType";
import { VideoInfo } from "../../../../common/components/listings/VideoInfo";
import { OrderAssetAvailability } from "../../../../common/types/OrderAssetAvailability";
import { OrderAssetStorageType } from "../../../../common/types/OrderAssetStorageType";
import { OrderRequestListingItem } from "../../OrderRequestListingItem";

export const renderOrderRequestVideos = (item?: OrderRequestListingItem): JSX.Element => {
    ensure(item);

    const hasAnyCloudAssetAvailable = [OrderAssetAvailability.FullMatch, OrderAssetAvailability.PartialMatch].includes(
        item.videos.cloud.availability
    );

    const nonMatchingVideos = [
        ...item.videos.cloud.nonMatchingVideos.map((video) => ({ ...video, assetType: AssetType.Cloud })),
        ...item.videos.onPrem.nonMatchingVideos.map((video) => ({ ...video, assetType: AssetType.OnPrem }))
    ];

    if (hasAnyCloudAssetAvailable) {
        return (
            <VideoInfo
                availability={item.videos.cloud.availability}
                isTrailer={item.isTrailer}
                requestedAspectRatio={item.targetAspectRatio}
                type={OrderAssetStorageType.Cloud}
                requestedResolution={item.targetResolution}
                nonMatchingVideos={nonMatchingVideos}
                testId={"order-requests-video-availability-status"}
            />
        );
    }

    return (
        <VideoInfo
            availability={item.videos.onPrem.availability}
            isTrailer={item.isTrailer}
            requestedAspectRatio={item.targetAspectRatio}
            type={OrderAssetStorageType.OnPrem}
            requestedResolution={item.targetResolution}
            nonMatchingVideos={nonMatchingVideos}
            testId={"order-requests-video-availability-status"}
        />
    );
};
